import React, {useState} from 'react';
import { useNavigate } from "react-router-dom";
//component
import Tab from '../../component/Inc/Tab';
import Paging from "../../component/Inc/Paging";
//css
import 'contents/assets/scss/page/teacher.scss';
function ManagePoint() {
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title:"포인트 승인요청", cnt:"45", value:0},
    {title:"포인트 승인 완료", cnt:"9898", value:1},
    {title:"내 승인요청", cnt:"233", type:"red", value:2},
  ];
  return (
    <main className="com_container">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu2_7 active'>
            포인트 관리
          </h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">포인트 정책</button>
            <button className="com_btn orange s btn_plus">포인트 요청</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className='com_board_list__top'>
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <article className='search'>
                <input type="search" placeholder='검색할 내용을 입력해 주세요.' className="input s type_search" />
                <button className="com_btn gray ws s icon_search"></button>
              </article>
            </div>
            <table className='com_board_list'>
              <colgroup>
                <col width="3.8%"/><col width="7.6%"/>
                <col width="6.3%"/><col width="6.3%"/>
                <col width="7%"/><col width="6.3%"/>
                <col width="8.1%"/><col width="%"/>
                <col width="5.7%"/><col width="5.7%"/>
                <col width="5.7%"/><col width="5.7%"/>
                <col width="5.7%"/><col width="5.7%"/>
                <col width="7.4%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th><th>요청일</th>
                  <th>요청자</th><th>지급자</th>
                  <th>부서</th><th>직급</th>
                  <th>요청항목</th><th>요청내용</th>
                  <th>요청포인트</th><th>총 지급P</th>
                  <th>보유P</th><th>진급P</th>
                  <th>진급가점</th><th>필요가점</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr onClick={() => navigate("/Manage/Point/Detail")}>
                  <td>20</td>
                  <td className='td_date'>2022.08.25</td>
                  <td><span className="btn_link">김요청305</span></td>
                  <td><span className="btn_link">홍길동101</span></td>
                  <td>전략기획실 / 마케팅</td>
                  <td>수석3호봉</td>
                  <td>교재제작검토</td>
                  <td>8월 초타오류 검수</td>
                  <td className='td_point'>+53</td>
                  <td>23</td>
                  <td>23</td>
                  <td>23</td>
                  <td>23</td>
                  <td>-</td>
                  <td className='td_red'>승인불가<br />2025.8.30</td>
                </tr>
                <tr onClick={() => navigate("/Manage/Point/Detail")}>
                  <td>20</td>
                  <td className='td_date'>2022.08.25</td>
                  <td><span className="btn_link">김요청305</span></td>
                  <td><span className="btn_link">홍길동101</span></td>
                  <td>전략기획실 / 마케팅</td>
                  <td>수석3호봉</td>
                  <td>교재제작검토</td>
                  <td>8월 초타오류 검수</td>
                  <td className='td_point'>+53</td>
                  <td>23</td>
                  <td>23</td>
                  <td>23</td>
                  <td>23</td>
                  <td>-</td>
                  <td className='td_point'>승인<br />2025.8.30</td>
                </tr>
              </tbody>
            </table>
            <Paging />
          </div>
        </section>
      </div>
    </main>
  );
}

export default ManagePoint;
